import { vietnamCenters, beautyPartners } from "@/mocks/homeData";

export default function VietnamSection() {
  return (
    <section id="vietnam" className="relative w-full bg-navy-900 py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20education%20center%20building%20in%20Vietnam%20with%20students%20from%20diverse%20backgrounds%20walking%20through%20bright%20glass%20corridors%2C%20warm%20natural%20lighting%20streaming%20through%20windows%2C%20contemporary%20Asian%20architecture%20with%20clean%20lines%20and%20greenery%2C%20professional%20corporate%20photography%20style%20with%20hopeful%20atmosphere%2C%20subtle%20cultural%20decorations&width=1200&height=600&seq=vietnam1&orientation=landscape"
          alt="베트남 교육센터 배경"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="animate-on-scroll text-center mb-12 md:mb-16">
            <p className="text-sky-300 text-sm font-semibold tracking-wider uppercase mb-3">
              Vietnam Cooperation
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-white">
              베트남 협력 인프라
            </h2>
            <p className="text-white/60 text-sm md:text-base mt-3 max-w-xl mx-auto">
              베트남 현지 교육센터와 협력 대학을 통해 안정적인 국제 교류를 실현합니다
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16">
            {vietnamCenters.map((center, index) => (
              <div
                key={index}
                className={`animate-on-scroll ${['delay-100','delay-200','delay-300'][index] || 'delay-100'} bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 border border-white/10 hover:border-sky-300/30 transition-all duration-300`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-sky-500/20 rounded-lg flex items-center justify-center">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-building-4-line text-sky-300 text-lg" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-white">{center.name}</h3>
                    <p className="text-xs text-white/60">{center.location}</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-white/70">수용 인원</span>
                    <span className="text-sm font-bold text-sky-300">{center.capacity}</span>
                  </div>
                  <div className="border-t border-white/10 pt-3">
                    <p className="text-xs text-white/50 mb-1.5">협력 대학</p>
                    {center.partners.map((partner, i) => (
                      <p key={i} className="text-sm text-white/80">{partner}</p>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="animate-on-scroll delay-400">
            <h3 className="text-lg md:text-xl font-bold text-white mb-6 text-center">
              K-Beauty 뷰티 교육 협력 대학
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              {beautyPartners.map((partner, index) => (
                <div
                  key={index}
                  className="bg-white/5 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-white/10 text-center"
                >
                  <div className="w-12 h-12 bg-sky-500/10 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-sky-300 font-bold text-sm">{partner.shortName}</span>
                  </div>
                  <h4 className="text-sm font-semibold text-white mb-1">{partner.name}</h4>
                  <p className="text-xs text-white/50">{partner.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}